import { TileContainer } from '@vds/tiles'
import React from 'react'
import './MultipleInstructorCard.scss'
import { Body, Micro, Title } from '@vds/typography'
import { isMobile } from 'react-device-detect'
import { ListItem, UnorderedList } from '@vds/lists'
import { decodeHTML } from '../../../utility/common'
import { navigateUsingLanguage } from '../../../utility/utils'

const MultipleInstructorCard = ({ instructors }) => {
  const handleCardClick = (url) => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    navigateUsingLanguage(url);
  }

  return (
    <div className="instructor_card_wrapper">
      {instructors?.map((item, index) => {
        const bioItem1 =  item?.bioitem1 ? item?.bioitem1 : item?.bio1;
        const bioItem2 =  item?.bioitem2 ? item?.bioitem2 : item?.bio2;
        const bioItem3 =  item?.bioitem3 ? item?.bioitem3 : item?.bio3;

        return <TileContainer
           key={`${item?.firstName ? item?.firstName : item?.fname} ${item?.lastName ? item?.lastName : item?.lname} + ${index}`}
          padding={!isMobile ? '24px' : '16px'}
          width='100%'
          height='100%'
          backgroundColor="#fff"
          showDropShadow={true}
          shadowStrong={true}
          tabIndex="0"
          ariaLabel={`${item?.firstName ? item?.firstName : item?.fname} ${item?.lastName ? item?.lastName : item?.lname} Instructor Card`}
          onClick={!item?.instructorID ? "" : () => handleCardClick(`/instructor-details/${item?.instructorID}`)}
        >
          <div className="instructor-card gap-4X n-flexDirectionCol n-displayFlex n-alignItemsCenter sm-n-flexDirectionRow">
            <img className="instructor-image" src={item?.profileimg ? global.config.AEM_API_BASE_PATH + item?.profileimg : item?.proImage} alt="Instructor Profile Image"></img>
            <div className="n-displayFlex n-textCenter height-100 n-flexDirectionCol sm-n-textLeft">
              <div className="n-displayFlex gap-2X mb-3X n-justifyContentCenter sm-n-justifyContentStart">
                <div className="flags"><Body size="small" bold>{item?.designation ? item?.designation : item?.tag}</Body></div>
              </div>
              <div className="align-center gap-1X n-flexDirectionCol n-textCenter mb-3X sm-n-alignItemsStart sm-n-textLeft">
                <div>
                  <Title size='small' bold>{item?.firstName ? item?.firstName : item?.fname}</Title>
                  <Title size='small' bold>{item?.lastName ? item?.lastName : item?.lname}</Title>
                </div>
                <div>
                  <Micro bold color='#6F7171'>{item?.jobTitle}</Micro>
                  <Micro color='#6F7171'>{item?.companyname ? item?.companyname : item?.cmpnyName}</Micro>
                </div>
              </div>
              <div className='sm-hide height-100 n-textLeft'>
                <UnorderedList>
                  {bioItem1 && <ListItem
                    size="micro"
                    spacing="compact"
                  >
                    {decodeHTML(bioItem1)}
                  </ListItem>}
                  {bioItem2 && (
                    <ListItem
                      size="micro"
                      spacing="compact"
                    >
                      {decodeHTML(bioItem2)}
                    </ListItem>
                  )}
                  {bioItem3 && (
                    <ListItem
                      size="micro"
                      spacing="compact"
                    >
                      {decodeHTML(bioItem3)}
                    </ListItem>
                  )}
                </UnorderedList>
              </div>
              {bioItem1 && <div className='hide sm-show'><Micro>{bioItem1 && decodeHTML(bioItem1)}</Micro></div>}
            </div>
          </div>
        </TileContainer>
      }
      )}
    </div>
  )
}

export default MultipleInstructorCard